import { forwardRef, type Ref, type SVGProps } from "react";
const IconFileCSVFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M28 13h-1V9.84a2.02 2.02 0 0 0-.58-1.41l-5.83-5.84A1.97 1.97 0 0 0 19.18 2H7a2.006 2.006 0 0 0-2 2v9H4a2.006 2.006 0 0 0-2 2v9a2.006 2.006 0 0 0 2 2h1v2a2.006 2.006 0 0 0 2 2h18a2.006 2.006 0 0 0 2-2v-2h1a2.006 2.006 0 0 0 2-2v-9a2.006 2.006 0 0 0-2-2M7 4h11v5a2.006 2.006 0 0 0 2 2h5v2H7Zm17.38 12.87-1.92 5.33h-1.52l-1.93-5.33h1.44l1.26 4.08h.05L23 16.87Zm-8.46 3.19-.88-.18c-.83-.17-1.52-.59-1.52-1.49 0-1.05.98-1.63 2.23-1.63 1.31 0 2.19.65 2.2 1.6h-1.16c-.03-.38-.37-.73-1.05-.73-.6 0-.97.26-.97.67 0 .31.27.52.8.61l.89.18c.86.17 1.58.55 1.58 1.52 0 1.05-.89 1.69-2.35 1.69-1.73 0-2.29-.88-2.31-1.63h1.2c.04.39.43.74 1.17.74.69 0 1.06-.28 1.06-.69 0-.36-.3-.54-.89-.66m-6.06 1.29a1.012 1.012 0 0 0 1.13-1.01h1.19v.12c0 .97-.85 1.84-2.34 1.84a2.257 2.257 0 0 1-2.48-2.46v-.6a2.272 2.272 0 0 1 2.49-2.47c1.45 0 2.33.85 2.33 1.89v.11h-1.19a1.054 1.054 0 0 0-1.13-1.06c-.75 0-1.24.51-1.24 1.53v.6c0 1.03.49 1.51 1.24 1.51M25 28H7v-2h18Z" />
  </svg>
);
const ForwardRef = forwardRef(IconFileCSVFilledSVG);
ForwardRef.displayName = "IconFileCSVFilled";
export { ForwardRef as IconFileCSVFilled };
